String.prototype.capitalize = function () {
  return this.charAt(0).toUpperCase() + this.slice(1).toLowerCase();
}

Date.prototype.getTimezoneMilliOffset = function () {
  return this.getTimezoneOffset() * 60 * 1000;
};

Date.prototype.getISODay = function () {
  let day = this.getDay();

  day -= 1;

  return day === -1 ? 6 : day;
};

Date.prototype.getCeilQuarterHour = function () {
  let clone = new Date(this);

  if (clone.getMinutes() > 52) {
    if (clone.getHours() === 23) {
      clone.setHours(0);
    } else {
      clone.setHours(clone.getHours() + 1);
    }
  }

  clone.setMinutes((Math.ceil(clone.getMinutes() / 15) * 15) % 60);
  clone.setSeconds(0);
  clone.setMilliseconds(0);

  return clone;
};

Date.prototype.getFloorQuarterHour = function () {
  let clone = new Date(this);

  clone.setMinutes((Math.floor(clone.getMinutes() / 15) * 15) % 60);
  clone.setSeconds(0);
  clone.setMilliseconds(0);

  return clone;
};

String.prototype.replaceAll = function (search, replacement) {
  let target = this;
  return target.replace(new RegExp(search, "g"), replacement);
};
